import Dir from './dir'

export default Dir
